import {CredentialType} from "@yosmanyga/base";

abstract class AuthenticationFrontendAsGuestAbstractApi {
    abstract complete: () => Promise<CredentialType>
}

export {
    AuthenticationFrontendAsGuestAbstractApi
}
